// React core.
import React from 'react';

// Firebase.
import firebase from 'firebase/app';
import 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import BaseComponent from '../../components/system/base';

// Styles
import styles from './app.css'; // This uses CSS modules.

// Context
import FireBaseContext from '../../context/fireBaseContext';

const $ = window;
let postMessageProxy = function(message) {
  if ($.ReactNativeWebView !== undefined) {
    setTimeout(() => {
      $.ReactNativeWebView.postMessage(message);
    }, 0);
  }
}

class Auth extends BaseComponent {
  static contextType = FireBaseContext;

  uiConfig = {
    signInFlow: 'popup',
    'signInOptions': [
      // The Provider you need for your app. We need the Phone Auth
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      {
        provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,

      },
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        requireDisplayName: true,
        recaptchaParameters: {
          type: 'image', // another option is 'audio'
          size: 'invisible', // other options are 'normal' or 'compact'
          badge: 'bottomleft' // 'bottomright' or 'inline' applies to invisible.
        }
      }
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => false,
    },
  };

  state = {
    isSignedIn: undefined,
  };

  /**
   * @inheritDoc
   */
  componentDidMount() {
    this.unregisterAuthObserver = this.context.firebase.auth().onAuthStateChanged((user) => {
      if (user !== undefined && user !== null) {
        this.context.firebase.firestore().collection("users").doc(user.uid).set({UserId: user.uid});
      }
      this.setState({isSignedIn: !!user});
    });
  }

  /**
   * @inheritDoc
   */
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  /**
   * @inheritDoc
   */
  render() {
    return (
      <div className={styles.container}>
        {this.state.isSignedIn !== undefined && !this.state.isSignedIn &&
          <div style={this.globs.GetVar("mode") === "select" ? {marginTop: 150}: {}}>
            {this.globs.GetVar("mode") !== "select" &&
              <div className="center">
                <img id="mainFish" style={{marginTop: 5, width: "100%"}} src="/images/content/login/Fish-Home.png" alt="Main Fish" {...this.globs.touchAndClick((e) => {
                  postMessageProxy("qr")
                })}/>
              </div>
            }
            <StyledFirebaseAuth className={styles.firebaseUi} uiConfig={this.uiConfig}
                                firebaseAuth={this.context.firebase.auth()}/>
          </div>
        }
      </div>
    );
  }
}


export default Auth


// WEBPACK FOOTER //
// ./src/content/auth/auth.js